import { type SupportedCurrencies } from 'dibs-currency-helpers/exports/currencies.ts';
import { useCurrencyStore } from 'dibs-buyer-layout/exports/currencyStore.ts';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

// For SSR we use the currency from the ServerVarsContext, for CSR we use the currency from the currencyStore.
// Both currencies should match and that's handled in @prepareRoute.ts on ABF side and in @currencyStore.ts in DBL package.
export const useCurrency = (): { currency: SupportedCurrencies; showCurrency: boolean } => {
    const { currency: storeCurrency, showCurrency } = useCurrencyStore();
    const { serverCurrency } = useServerVarsContext();

    return {
        currency: serverCurrency && !showCurrency ? serverCurrency : storeCurrency,
        showCurrency,
    };
};
